import { render } from "./CreditTemplate.vue?vue&type=template&id=aef22d96&scoped=true&ts=true"
import script from "./CreditTemplate.vue?vue&type=script&lang=ts"
export * from "./CreditTemplate.vue?vue&type=script&lang=ts"

import "./CreditTemplate.vue?vue&type=style&index=0&id=aef22d96&lang=scss&scoped=true"

import exportComponent from "/Users/hirosuke-pi/projects/vr-jmof-front-2020/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aef22d96"]])

export default __exports__